import {
  UpdateIconButton,
  formatDate,
  pn,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CrudMode,
} from "@compass/core";
import { ListBeProperty } from "components";
import {
  Permission,
  PermissionAction,
  SortObject,
  StudentApplicationListDto,
  StudentApplicationListResource,
} from "generated/openApi";
import { useNavigate } from "react-router-dom";
import { isAuthorized } from "services";
import { studentApplicationPageRoute } from "../StudentApplicationPage/StudentApplicationPage";

export const StudentApplicationTable = (props: {
  openNewTab: boolean;
  rootPermission: Permission;
  tableContainerRef: React.RefObject<HTMLDivElement>;
  studentApplications: StudentApplicationListDto[];
  listTotal: number | undefined;
  resource: StudentApplicationListResource;
  searchFocused: boolean;
  sortObjects: SortObject[] | undefined;
  sort: (sortObjects: SortObject[]) => void;
  selectId: (id: number) => void;
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  getIdsPromise: () => Promise<any>;
}) => {
  const navigate = useNavigate();
  const properties = props.resource.properties || [];

  const navigateApplicationResponseView = (applicationResponse: StudentApplicationListDto, crudMode: CrudMode) => {
    if (props.openNewTab) {
      var route = `/studentApplications/${studentApplicationPageRoute.getPath({
        applicationResponseId: applicationResponse.id,
        crudMode: crudMode,
      })}`;
  
      window.open(route, "_blank");
    }
    else {
      navigate(studentApplicationPageRoute.getPath({ applicationResponseId: applicationResponse.id, crudMode: crudMode }))
    }
  };

  return (
    <TableContainer ref={props.tableContainerRef}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentApplicationListDto>("lastName"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>

            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentApplicationListDto>("firstName"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>

            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentApplicationListDto>("schoolName"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentApplicationListDto>("applicationStatus"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>
            <TableCell>
              <ListBeProperty
                listProperty={properties.find((x) => x.propertyName === pn<StudentApplicationListDto>("submittedDate"))}
                sortObjects={props.sortObjects}
                onChange={(sortObjects) => props.sort(sortObjects)}
                searchFocused={props.searchFocused}
              />
            </TableCell>

            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.studentApplications.map((studentApplicationItem) => (
            <TableRow
              key={studentApplicationItem.id}
              onClick={() => navigateApplicationResponseView(studentApplicationItem, "view")}
            >
              <TableCell>{studentApplicationItem.lastName}</TableCell>
              <TableCell>{studentApplicationItem.firstName}</TableCell>
              <TableCell>{studentApplicationItem.schoolName}</TableCell>
              <TableCell>{studentApplicationItem.applicationStatus?.name}</TableCell>
              <TableCell>{formatDate(studentApplicationItem.submittedDate)}</TableCell>
              <TableCell type="action">
                {isAuthorized(props.rootPermission, PermissionAction.Update) && (
                  <UpdateIconButton
                  onClick={() => navigateApplicationResponseView(studentApplicationItem, "edit")}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
